export const TWITTER_ACTION_ICON_PATHS: string[] = [
  'socialmedia/comment-icon-twitter.svg',
  'socialmedia/repost-icon-twitter.svg',
  'socialmedia/like-icon-twitter.svg',
  'socialmedia/views-icon-twitter.svg',
  'socialmedia/share-icon-twitter.svg',
];
